import APIError from '../APIError';

class CrowdfundingInvestmentError extends APIError {
  constructor(code, details = null) {
    super(code, 'CrowdfundingInvestmentError', details);
  }
}

export default CrowdfundingInvestmentError;
